export const targetHost = import.meta.env.VITE_TARGET_HOST;
export const appPageUrl = import.meta.env.VITE_APP_URL;
export const environment = import.meta.env.VITE_NODE_ENV;
export const isProduction = environment === 'production';
export const isDevelopment = environment === 'development';
export const isLocal = environment === 'local';
export const appVersion: string = import.meta.env.VITE_VERSION;
export const appVersionDate: string = import.meta.env.VITE_VERSION_DATE;
export const shortSha: string = import.meta.env.VITE_COMMIT_SHA;
export const sla = { total: 48, warning: 1 };
export const templateId = isProduction
  ? import.meta.env.VITE_PROD_TEMPLATE_MAIL_ID
  : import.meta.env.VITE_DEV_TEMPLATE_MAIL_ID;
export const showUsaFeature = import.meta.env.VITE_FEATURE_US === 'true';
export const showWorklistFeature = import.meta.env.VITE_FEATURE_WORKLIST === 'true';
export const showBloodPressureFeature = import.meta.env.VITE_FEATURE_BLOODPRESSURE === 'true';
export const showWeightFeature = import.meta.env.VITE_FEATURE_WEIGHT === 'true';

export const udiLabel = `(01)05419980589316(8012)${showUsaFeature ? `US` : `EU`}_v${appVersion}`;
